<div class="insurance-type family-type-colored"
     [ngClass]="typeSource$ | async"
     [class.lifeislife-badge]="badge"
>
  <span class="label">{{ label$ | async}}</span>
</div>
